var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"myCheck"},[_c('label',{staticClass:"checkbox_label",attrs:{"for":_vm.name}},[(_vm.isCheck)?_c('span',{staticClass:"icon pre lx-pointer"}):_c('span',{staticClass:"icon nor lx-pointer"})]),_vm._t("checkbox")],2)}
var staticRenderFns = []

export { render, staticRenderFns }